// extracted by mini-css-extract-plugin
module.exports = {"contImaTarjeta":"styles_contImaTarjeta__DjrqU","cardImage":"styles_cardImage__1wmtv"};